import React, { useState } from "react";

export const ShowItem = ({ url, setShowItems, loadingImage }) => {
  const [isLoading, setIsLoading] = useState(true);

  const handleCloseImage = (e) => {
    e.stopPropagation();
    setShowItems(false);
  };

  const handleImageLoad = () => {
    setIsLoading(false);
  };

  const getImageSrc = () => {
    if (url?.imgRip) {
      return `data:image/bmp;base64,${url.imgRip}`;
    }
    return url;
  };

  return (
    <div className="fixed top-0 left-0 right-0 bottom-0 bg-[#00000073] z-50 " onClick={handleCloseImage}>
      <div className="w-[600px]  m-auto my-[5%] bg-white rounded-lg py-[15px] px-[15px]">
        {!loadingImage && (
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
          </div>
        )}
        <div className="text-center text-2xl">
          {loadingImage && url?.order}
        </div>
        {loadingImage && (
          <img 
            src={getImageSrc()} 
            alt="" 
            className="w-auto h-auto"
            onLoad={handleImageLoad}
            style={{ opacity: isLoading ? 0 : 1 }}
          />
        )}
      </div>
    </div>
  );
};
